import React from 'react'
import { Box } from '@mui/material'
import SideBar from '../components/layout/SideBar'
import Footer from '../components/Footer'
import InnerContainer from '../components/auth/InnerContainer'
import ChangePasswordSection from '../components/auth/ChangePasswordSection'

const ChangePasswordScreen = () => {
  return (
    <>
      <Box sx={{ display: 'flex', height: '98vh' }}>
        <SideBar />
        {/* parent */}
        <Box
          component='main'
          sx={{
            flexGrow: 1,
            marginBottom: 2,
            marginRight: 2,
            marginTop: 9,
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: 2,
          }}>
          {/* Main Box */}
          <InnerContainer>
            <ChangePasswordSection />
          </InnerContainer>
        </Box>
      </Box>

      {/* Footer */}
      <Box component='footer' sx={{ height: '10px' }}>
        <Footer />
      </Box>
    </>
  )
}

export default ChangePasswordScreen
